import React, { Component } from "react";
import HYUNDAI_ICON from "../../../styles/images/brands/hyundai.svg";

import "../../../styles/components/legal/Legal.scss";

class Privacy extends Component {
  render() {
    return (
      <div id="privacy">
        <div>
          <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
          <title />
          <meta name="generator" content="LibreOffice 6.4.7.2 (Linux)" />
          <meta name="author" content="Diogo Figueira" />
          <meta name="created" content="2023-06-20T11:28:00" />
          <meta name="changed" content="2023-06-26T10:46:06.608495588" />
          <meta name="AppVersion" content={16.0} />
          <meta
            name="ContentTypeId"
            content="0x0101000BB2643375481343AFB5489E80F1ADEF"
          />
          <meta name="DocSecurity" content={0} />
          <meta name="HyperlinksChanged" content="false" />
          <meta name="LinksUpToDate" content="false" />
          <meta name="MediaServiceImageTags" content />
          <meta name="ScaleCrop" content="false" />
          <meta name="ShareDoc" content="false" />
          <style
            type="text/css"
            dangerouslySetInnerHTML={{
              __html:
                "\n\t\t@page { size: 21cm 29.7cm; margin-left: 3cm; margin-right: 3cm; margin-top: 1.25cm; margin-bottom: 1.25cm }\n\t\tp { margin-bottom: 0.25cm; direction: ltr; line-height: 115%; text-align: left; orphans: 2; widows: 2; background: transparent }\n\t\ta:link { color: #0563c1; text-decoration: underline }\n\t",
            }}
          />
          <div title="header">
            <p
              align="center"
              style={{ marginBottom: "1.15cm", lineHeight: "100%" }}
            >
              <br />
            </p>
            <p
              align="center"
              style={{
                marginTop: "0.21cm",
                marginBottom: "0cm",
                lineHeight: "0.6cm",
              }}
            >
              <img
                className="brand-img"
                src={HYUNDAI_ICON}
                name="Picture 1"
                align="bottom"
                height={200}
                border={0}
                alt="Acp"
              />
            </p>
            <p
              align="center"
              style={{ marginBottom: "1.15cm", lineHeight: "100%" }}
            >
              <br />
            </p>
          </div>
          <p
            align="center"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <font face="Arial Narrow, serif">
              <font size={4} style={{ fontSize: "16pt" }}>
                <u>
                  <b>POLÍTICA DE PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS</b>
                </u>
              </font>
            </font>
          </p>
          <p style={{ marginBottom: "0.28cm", lineHeight: "108%" }}>
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            A HYUNDAI respeita a privacidade individual e valoriza a confiança
            dos seus clientes e parceiros, assumindo com grande seriedade as
            suas responsabilidades no que se refere à segurança destes mesmos
            dados.
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            Neste contexto, damos a conhecer a política de privacidade da
            HYUNDAI, que explica que dados pessoais recolhemos, para que
            finalidades os podemos usar, como os tratamos, com quem os
            partilhamos, durante quanto tempo os conservamos bem como as formas
            de entrar em contacto connosco e exercer os seus direitos.
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <ol>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Quem é o responsável pelo tratamento dos seus dados? </b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            A HYUNDAI, S.A, sociedade comercial anónima de Direito Português,
            pessoa coletiva n.º 500&nbsp;820 384, registada sob o mesmo número
            na 1.ª Secção da Conservatória do Registo Comercial de Vila Nova de
            Gaia, com sede na Rua Daciano Baptista Marques, 245, 5º C, Edifício
            D - Lake Towers, 4400-617 Vila Nova de Gaia, , é a entidade
            responsável pelo tratamento dos seus dados.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Nos casos em que, através da nossa plataforma, proceda à celebração
            de um contrato para fornecimento de energia elétrica na rede pública
            da MOBI.E, a EVIO – Electrical Mobility, S.A. (doravante EVIO), com
            sede na Av. D. Afonso Henriques, 1825, 4450-017 Matosinhos, na
            qualidade de Comercializador de Energia Elétrica (“CEME) será também
            responsável pelo tratamento dos seus dados. Esta entidade poderá
            também proceder a recolhas autónomas dos seus dados diretamente
            junto de si e ter a sua própria política de privacidade, razão pela
            qual deverá contactar tal entidade em caso de alteração ou questão
            relativa à utilização que aquela faz dos seus dados. Em tais casos,
            a HYUNDAI não terá qualquer responsabilização ou intervenção.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Ainda, nos casos em que, através da nossa plataforma, proceda à
            celebração de um contrato de prestação de serviços para a mobilidade
            elétrica com a GOCHARGE, S.A. (doravante designada GOCHARGE), com
            sede na Avenida Vasco da Gama, 1410, 4430-247 Vila Nova de Gaia,
            esta será também responsável pelo tratamento dos seus dados. Esta
            entidade poderá também proceder a recolhas autónomas dos seus dados
            diretamente junto de si e ter a sua própria política de privacidade,
            razão pela qual deverá contactar tal entidade em caso de alteração
            ou questão relativa à utilização que aquela faz dos seus dados. Em
            tais casos, a HYUNDAI não terá qualquer responsabilização ou
            intervenção.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ol start={2}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Que informação recolhemos sobre si? </b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            A HYUNDAI apenas recolhe e trata os dados pessoais que sejam
            diretamente fornecidos por si, nomeadamente seja através do
            preenchimento de algum formulário de contacto, seja através da
            aquisição de um produto ou serviço HYUNDAI, que, em geral, serão,
            consoante o caso, os seguintes:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <dl>
            <dd>
              <table width={"100%"} cellPadding={7} cellSpacing={0}>
                <colgroup>
                  <col width={"40%"} />
                  <col width={"60%"} />
                </colgroup>
                <tbody>
                  <tr valign="top">
                    <td style={{ background: "transparent" }}>
                      <p align="center">
                        <b>CATEGORIA DE DADOS</b>
                      </p>
                    </td>
                    <td style={{ background: "transparent" }}>
                      <p align="center">
                        <font color="#000000">
                          <b>EXEMPLOS</b>
                        </font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify">
                        <font color="#000000">
                          <b>Dados de identificação </b>
                        </font>
                      </p>
                    </td>
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify">
                        <font color="#000000">
                          Nome, números e datas de validade de documentos de
                          identificação civil (e respetivas imagens), entre
                          outros.{" "}
                        </font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <font color="#000000">
                          <b>Dados de contacto </b>
                        </font>
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify">
                        <br />
                      </p>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="justify">
                        <font color="#000000">Morada, telemóvel, e-mail.</font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <font color="#000000">
                          <b>Dados económicos e transacionais</b>
                        </font>
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify">
                        <br />
                      </p>
                    </td>
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify">
                        <font color="#000000">Dados Bancários.</font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <font color="#000000">
                          <b>Dados de histórico cliente </b>
                        </font>
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify">
                        <br />
                      </p>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="justify">
                        <font color="#000000">
                          Respostas a Inquéritos de Satisfação, Número Cliente,
                          Número Contrato, Histórico de Reclamações, entre
                          outros.
                        </font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify">
                        <font color="#000000">
                          <b>Dados de utilização das plataformas </b>
                        </font>
                      </p>
                    </td>
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify">
                        <font color="#000000">
                          Login, password, número de registo, entre outros.{" "}
                        </font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <font color="#000000">
                          <b>Dados do veículo </b>
                        </font>
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify">
                        <br />
                      </p>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="justify">
                        <font color="#000000">
                          Matrícula, dados de consumo, localização (quando
                          ativada por si), entre outros.{" "}
                        </font>
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <font color="#000000">
                          <b>Dados de Aplicação, Internet e Redes Sociais</b>
                        </font>
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify">
                        <br />
                      </p>
                    </td>
                    <td bgcolor="#f2f2f2" style={{ background: "#f2f2f2" }}>
                      <p align="justify">
                        <a name="_Hlk508897400 " />
                        <font color="#000000">
                          Localização, utilização do website e das redes sociais
                          da HYUNDAI.
                        </font>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </dd>
          </dl>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <ol start={3}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Como e porque utilizamos os seus dados pessoais?</b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Usamos os seus dados pessoais para:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <dl>
            <dd>
              <table width={"100%"} cellPadding={7} cellSpacing={0}>
                <colgroup>
                  <col width={"40%"} />
                  <col width={"60%"} />
                </colgroup>
                <tbody>
                  <tr valign="top">
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.1x9cm",
                      }}
                    >
                      <p align="center">
                        <b>FINALIDADE</b>
                      </p>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <p align="center">
                        <b>EXEMPLOS</b>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>
                              Gestão de cliente, execução e cumprimento das
                              nossas obrigações pré-contratuais e contratuais.{" "}
                            </b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Responder às suas solicitações
                          </p>
                        </li>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">
                            Executar os serviços constantes e referidos nos
                            Termos e Condições.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={2}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>
                              Comunicar e gerir a nossa relação contratual
                              consigo
                            </b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Contactar consigo por motivos administrativos e/ou
                            operacionais, assegurando que gerimos corretamente a
                            sua relação connosco e resolvemos a sua solicitação
                            e/ou pedido.
                          </p>
                        </li>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">
                            Gravação de chamadas para monitorização da qualidade
                            de serviço.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={3}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>
                              Personalizar e melhorar a sua experiência de
                              cliente
                            </b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">
                            Contactar consigo para a realização de Inquéritos de
                            Satisfação sobre os nossos serviços. Entendemos que
                            temos um interesse legítimo no tratamento dos seus
                            dados pessoais para esta finalidade, a qual
                            entendemos ser igualmente benéfica para si porquanto
                            nos permite melhor servi-lo e garantir-lhe a maior
                            satisfação possível enquanto nosso Cliente. A
                            qualquer momento, pode nos informar de que não
                            pretende mais ser contactado para estes efeitos.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={4}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>Marketing</b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Caso seja nosso Cliente, usaremos os seus dados
                            pessoais para lhe fornecer notícias nossas, tais
                            como novas ofertas, novas campanhas e novos serviços
                            HYUNDAI de que poderá gostar. Consideramos ter um
                            interesse legítimo no envio desta informação, uma
                            vez que será igualmente benéfico para si, permitindo
                            melhorar a sua experiência e aceder a informação que
                            acreditamos ser do seu total interesse.
                          </p>
                        </li>
                      </ul>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Caso não seja nosso Cliente, usaremos os seus dados
                            pessoais para o informar de ofertas de que poderá
                            gostar, apenas quando nos tenha dado o seu expresso
                            consentimento para o efeito, por exemplo, quando
                            preenche um formulário de contacto e assinala tal
                            opção.
                          </p>
                        </li>
                      </ul>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        Para estes efeitos, poderemos ainda proceder a uma
                        análise do seu perfil de utilizador ou cliente,
                        nomeadamente através do seu histórico de navegação e/ou
                        histórico de compras, para determinar quais são as suas
                        preferências e, assim, enviar-lhe informação
                        personalizada.
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}></p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        Utilizaremos ainda os seus dados pessoais para lhe
                        enviar comunicações de produtos e serviços de mobilidade
                        das sociedades participadas da Salvador Caetano Auto,
                        SGPS, S.A., no caso de nos ter dado seu expresso e
                        explícito consentimento para o efeito.
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        Em momento algum, partilharemos os seus dados pessoais
                        com outras entidades terceiras para efeitos de
                        marketing, exceto se tivermos o seu expresso e explícito
                        consentimento.
                      </p>
                      <p align="justify" style={{ marginBottom: "0cm" }}>
                        <br />
                      </p>
                      <p align="justify">
                        Caso não queira receber comunicações de marketing
                        HYUNDAI, pode dizer-nos isso mesmo a qualquer momento,
                        ao clicar na ligação para o efeito na parte inferior de
                        qualquer e-mail de marketing que receber da HYUNDAI. Se
                        preferir, pode sempre expressar a sua preferência em não
                        receber comunicações de marketing para o e-mail{" "}
                        <a href="mailto:suporte_blue@hyundai.pt">
                          suporte_blue@hyundai.pt
                        </a>
                        .
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={5}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>Cumprirmos as nossas obrigações legais</b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      width={245}
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Prestar-lhe assistência no âmbito de obrigações
                            legais que possam recair sobre nós.
                          </p>
                        </li>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">
                            Resposta a entidades judiciais, de regulação e de
                            supervisão.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={6}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>Gerir o seu registo como utilizador</b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      width={245}
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">
                            Caso se registe como utilizador de aplicação, área
                            reservada ou plataforma propriedade da HYUNDAI,
                            necessitamos tratar os seus dados para o identificar
                            como utilizador em tais plataformas e dar-lhe a
                            possibilidade de aceder às diversas funcionalidades,
                            produtos e serviços que estão ao dispor como
                            utilizador registado.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={7}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>Gestão de Contencioso</b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Cobrança judicial e extrajudicial.
                          </p>
                        </li>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">Gestão de outros conflitos.</p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ol
                        start={8}
                        style={{
                          marginLeft: "0.5cm",
                        }}
                      >
                        <li>
                          <p align="justify">
                            <b>
                              Gestão Contabilística, Fiscal e Administrativa
                            </b>
                          </p>
                        </li>
                      </ol>
                    </td>
                    <td
                      style={{
                        border: "1px solid #000000",
                        padding: "0cm 0.19cm",
                      }}
                    >
                      <ul>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify" style={{ marginBottom: "0cm" }}>
                            Contabilidade e faturação.
                          </p>
                        </li>
                        <li
                          style={{
                            marginLeft: "0.5cm",
                          }}
                        >
                          <p align="justify">
                            Informação Fiscal, incluindo envio de informação à
                            Autoridade Tributária.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </dd>
          </dl>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <ol start={4}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>
                      De que forma mantemos os seus dados pessoais seguros e
                      durante quanto tempo conservaremos os seus dados?
                    </b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Implementámos medidas técnicas e organizativas para proteger os seus
            dados pessoais contra a destruição, acidental ou ilícita, a perda
            acidental, a alteração, a difusão ou o acesso não autorizado aos
            mesmos.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Nem todos os dados anteriormente referidos são obrigatoriamente
            tratados pela HYUNDAI. Ao registar-se na plataforma, o Utilizador
            terá de fornecer obrigatoriamente apenas os seguintes dados: número
            de telemóvel, e-mail e password.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Quantos aos dados de localização, por defeito a funcionalidade de
            geolocalização está desligada. Cabe ao utilizador ativar a partilha
            da sua localização nas definições do seu dispositivo móvel e dar as
            permissões respetivas à aplicação Hyundai Blue, sendo que esta
            apenas tratará os dados de localização para indicar ao Utilizador
            o(s) posto(s) de carregamento mais próximo(s) ou para o ajudar na
            definição de um trajeto. Em qualquer momento, o utilizador poderá
            desativar a funcionalidade da geolocalização, sem justificação
            necessária e sem quaisquer repercussões negativas.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            O Utilizador poderá aceitar receber notificações push através das
            definições do seu equipamento móvel. Do mesmo a HYUNDAI poderá
            enviar comunicações ao utilizador via carta, e-mail, SMS e
            notificações push relativas às funcionalidades da plataforma ou à
            alteração do seu funcionamento.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Para usufruir de serviços adicionais e que envolvem pagamento, o
            Utilizador terá de inserir os dados referentes ao(s) seu(s)
            cartão(ões) de pagamento – número, data de validade e o Valor de
            Verificação de Cartão (CVV).
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            O prazo de conservação dos seus dados dependerá das finalidades para
            as quais os tratamos, ou seja, tratamos os seus dados durante o
            tempo estritamente necessário para cumprir a finalidade
            correspondente e, eventualmente, conservamos posteriormente os
            mesmos, devidamente guardados e protegidos, durante o tempo em que
            puderem surgir responsabilidades decorrentes do tratamento,
            cumprimento a legislação vigente em cada momento.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Quanto às nossas comunicações de Marketing, informamos o seguinte:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Caso nos tenha dado o seu consentimento para efeitos de
                Marketing, os seus dados pessoais irão ser conservados até ao
                prazo máximo de 2 anos a partir da recolha do seu consentimento
                ou, caso tenha adquirido algum produto e/ou serviço HYUNDAI,
                pelo período de 5 anos a contar da concessão do seu
                consentimento;
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{
              marginLeft: "2.54cm",
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Caso seja nosso cliente e havendo interesse legítimo para o
                contacto via e-mail, iremos guardar os seus dados até nos dizer
                que não mais o pretende após clicar na ligação para o efeito na
                parte inferior de qualquer e-mail de marketing que receber da
                HYUNDAI
              </p>
            </li>
          </ul>
          <p
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Caso necessite de esclarecimentos adicionais sobre as medidas de
            segurança implementadas bem como sobre os prazos concretos de
            conservação dos dados, agradecemos contacto para o e-mail{" "}
            <a href="mailto:suporte_blue@hyundai.pt">suporte_blue@hyundai.pt</a>
            .
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ol start={5}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Com quem partilhamos os seus dados pessoais? </b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Os seus dados pessoais são tratados com a máxima confidencialidade e
            são utilizados única e exclusivamente para as finalidades
            identificadas.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            A HYUNDAI garante que nunca procederá à venda, empréstimo ou
            cedência dos seus dados pessoais a terceiros, sem que haja o seu
            expresso e explícito consentimento para o efeito.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Conforme anteriormente referido, os seus dados pessoais serão
            partilhados com a EVIO – Electrical Mobility, S.A. (doravante EVIO),
            com sede na Av. D. Afonso Henriques, 1825, 4450-017 Matosinhos, na
            qualidade de Comercializador de Energia Elétrica (“CEME), na
            qualidade de responsável pelo tratamento dos seus dados no caso da
            celebração de um contrato de fornecimento de energia elétrica na
            rede pública da MOBI.E ou no caso de carregamentos ad hoc na rede
            MOBI.E através de contratos instantâneos com a EVIO.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Enquanto entidade responsável pelo desenvolvimento e manutenção da
            plataforma Hyundai Blue, a EVIO terá também acesso aos seus dados
            pessoais, enquanto subcontratante da HYUNDAI, sendo que a sua
            política de privacidade pode igualmente ser consultada em{" "}
            <a href="https://evio.pt/">https://evio.pt/</a> .
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Também como anteriormente mencionado, os seus dados serão
            partilhados com a GOCHARGE, S.A. (doravante designada GOCHARGE), com
            sede na Avenida Vasco da Gama, 1410, 4430-247 Vila Nova de Gaia), na
            qualidade de responsável pelo tratamento dos seus dados, no caso da
            celebração de um contrato de prestação de serviços para a mobilidade
            elétrica com esta entidade.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            A política de privacidade da GOCHARGE está disponível no seguinte
            endereço:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <a href="https://www.gocharge.pt/pt/politica-de-privacidade/">
              https://www.gocharge.pt/pt/politica-de-privacidade/
            </a>
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Por outro lado, para garantirmos o devido seguimento às suas
            solicitações bem como lhe garantirmos a melhor assistência possível,
            os seus dados pessoais poderão ser partilhados com os nossos
            fornecedores ou prestadores de serviços, por exemplo:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Instituições Financeiras
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Prestadores de serviços tecnológicos
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Prestadores de serviços relacionados com o apoio ao cliente.
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            A HYUNDAI garante que todas as entidades referidas acima se
            encontram igualmente munidas de medidas técnicas e organizativas
            para garantir a total proteção dos seus dados pessoais e que os
            mesmos apenas tratarão dos seus dados para cumprimento integral das
            finalidades inerentes à execução do contrato.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Caso os seus dados pessoais tenham que ser partilhados com entidades
            que não estejam localizadas no Espaço Económico Europeu, a HYUNDAI
            garante que as mesmas se encontram obrigadas a respeitar a
            legislação europeia relativa à proteção de dados pessoais,
            nomeadamente através da celebração de acordos de transferências
            internacionais de dados com cláusulas contratuais tipo para o
            efeito.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Caso necessite de esclarecimentos adicionais sobre os concretos
            destinatários dos seus dados e as salvaguardas específicas que foram
            aplicadas à transferência dos seus dados, agradecemos contacto para
            o e-mail{" "}
            <a href="mailto:suporte_blue@hyundai.pt">suporte_blue@hyundai.pt</a>
            .
          </p>
          <p
            align="justify"
            style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
          >
            <br />
            <br />
          </p>
          <ol start={6}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Quais são os seus direitos?</b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Tem o direito de, sempre que quiser e gratuitamente, pedir à HYUNDAI
            para:
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Aceder aos dados que nos indicou;
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Pedir a retificação dos seus dados;
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Pedir o apagamento dos seus dados;
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Pedir a limitação do tratamento dos seus dados;
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Opor-se ao tratamento dos seus dados;
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Solicitar a portabilidade dos seus dados para entidade por si
                indicada.
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Se nos facultou o seu consentimento para o tratamento dos seus dados
            para qualquer finalidade, tem direito também a retirá-lo em qualquer
            momento, através das formas já referidas na presente Política de
            Privacidade.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Para exercer qualquer um dos direitos referidos ou para qualquer
            esclarecimento adicional sobre o tratamento dos seus dados pessoais
            pela HYUNDAI, basta enviar um e-mail para{" "}
            <a href="mailto:suporte_blue@hyundai.pt">suporte_blue@hyundai.pt</a>
            .
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Caso exerça algum dos direitos mencionados, a HYUNDAI irá proceder à
            sua análise, garantindo uma resposta no prazo máximo de 1 (um) mês.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Note-se, porém, que caso exista norma ou obrigação legalmente
            imposta que se sobreponha a estes direitos, a HYUNDAI responderá a
            impossibilidade de executar o pedido, indicando o respetivo
            fundamento.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ol start={7}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Como fazer uma reclamação?</b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Caso não esteja satisfeito com a forma com que os seus dados
            pessoais se encontram a ser tratados pela HYUNDAI, agradecemos o seu
            contacto para{" "}
            <a href="mailto:suporte_blue@hyundai.pt">suporte_blue@hyundai.pt</a>
            .
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            No caso de se manter insatisfeito, tem o direito de apresentar uma
            reclamação diretamente à Comissão Nacional de Proteção de Dados,
            conforme dados infra:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Comissão Nacional de Proteção de Dados – CNPD
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Tel: +351 213928400
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                E-mail: <a href="mailto:geral@cnpd.pt">geral@cnpd.pt</a>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ol start={8}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Perguntas e comentários?</b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            Caso tenha alguma dúvida ou questão sobre a forma como tratamos os
            seus dados pessoais, poderá contactar-nos e contactar o Encarregado
            de Proteção de Dados (“EPD”), através dos seguintes e-mails:
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ul>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <span lang="en-US">
                  Email:{" "}
                  <a href="mailto:suporte_blue@hyundai.pt">
                    suporte_blue@hyundai.pt
                  </a>
                </span>
              </p>
            </li>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                Contacto do Encarregado de Proteção de Dados:{" "}
                <a href="mailto:epd@hyundai.pt">epd@hyundai.pt</a>
              </p>
            </li>
          </ul>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <ol start={9}>
            <li>
              <p
                align="justify"
                style={{ marginBottom: "0.28cm", lineHeight: "108%" }}
              >
                <font face="Arial Narrow, serif">
                  <font size={3} style={{ fontSize: "12pt" }}>
                    <b>Alterações à Política de Privacidade?</b>
                  </font>
                </font>
              </p>
            </li>
          </ol>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            A HYUNDAI reserva o direito de, a qualquer momento, proceder a
            modificações ou atualizações à presente Política de Privacidade,
            sendo essas alterações devidamente atualizadas na presente
            Plataforma.
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <br />
            <br />
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <i>Política de Privacidade Hyundai Blue</i>
          </p>
          <p
            align="justify"
            style={{
              marginBottom: "0.28cm",
              lineHeight: "108%",
            }}
          >
            <i>v. 1.0 – Data 20/06/2023</i>
          </p>
        </div>
      </div>
    );
  }
}

export default Privacy;
